import { render } from "./TrainingCourses.vue?vue&type=template&id=023629fe&scoped=true"
import script from "./TrainingCourses.vue?vue&type=script&lang=js"
export * from "./TrainingCourses.vue?vue&type=script&lang=js"

import "./TrainingCourses.vue?vue&type=style&index=0&id=023629fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023629fe"]])

export default __exports__